import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import * as txApi from '../clients/tx-sls-client'
import HourlyBigFish from './HourlyBigFish'
import DailyBigFish from './DailyBigFish'
import {config} from '../config'

const txdomain = config()['tourneyx-url']

const BigFish = ({tournamentId, tourneyType, length_measurement_symbol, weight_measurement_symbol,tournamentDetails,set_user_information}) => {

  const [hourlyBigFish, setHourlyBigFish] = useState([])
  const [dailyBigFish, setDailyBigFish] = useState([])
  const [show, setShow] = useState(false)
  const [day, setDay] = useState('')

  const hourly = (tourneyType === 1)

  const toggleShow = () => {
    setShow(!show);
  }

  useEffect(() => {
    txApi.getBigFish(tournamentId)
      .then(bigFish => {
        if(bigFish.hasOwnProperty("daily") && bigFish.hasOwnProperty("hourly") ) {
          const {daily, hourly} = bigFish
          
          //console.log('Hourly record op::', hourly);
          if(bigFish.hasOwnProperty("hourly")) {
            setHourlyBigFish(hourly)
          }
         
          setDailyBigFish(daily)
        }else if(bigFish.hasOwnProperty("daily") && !(bigFish.hasOwnProperty("hourly") )){
          const {daily, hourly} = bigFish

          setDailyBigFish(daily)

        }else if(bigFish.hasOwnProperty("hourly") && !(bigFish.hasOwnProperty("daily"))  ){
          const {daily, hourly} = bigFish
          
          setHourlyBigFish(hourly)
        } else {
          const daily = bigFish.pop()
          setDay(daily.dateSubmitted)
          setDailyBigFish([{...daily, first_name : daily.angler_name, last_name : ''}])
          setHourlyBigFish(bigFish)
        }
      })
      .catch(e => console.error(`Error getting big fish ${e}`))
  }, [tournamentId])

  return (
    <>
      <a target='#' onClick={toggleShow} className='right-btn' target="_blank">
        {/* Chaitraly 14/feb/2025 :: Added type-20 condition for TP-397 Jira card */}
        {tourneyType == 20 ? 
          (hourly ? 'Hourly Weigh-In' :  'Daily Small Fish') :
          (hourly ? 'Hourly Weigh-In' :  'Daily Big Fish')
        }
      </a>

        <Modal dialogClassName="big-fish" show={show} onHide={toggleShow} animation={false} centered>          
          <Modal.Header closeButton >
            <h4>
              {/* Chaitraly 14/feb/2025 :: Added type-20 condition for TP-397 Jira card */}
              {tourneyType == 20 ? 
                (hourly ? `Hourly Weigh-In ${day ? 'for ' + day : ''}` :  'Daily Small Fish') :
                (hourly ? `Hourly Weigh-In ${day ? 'for ' + day : ''}` :  'Daily Big Fish')
              }
            </h4>
          </Modal.Header>
          
          <Modal.Body >
            <div>
              {
                hourly ? <HourlyBigFish hourlyBigFish={hourlyBigFish} length_measurement_symbol = {length_measurement_symbol} weight_measurement_symbol = {weight_measurement_symbol} /> : <DailyBigFish dailyBigFish={dailyBigFish} length_measurement_symbol = {length_measurement_symbol} weight_measurement_symbol = {weight_measurement_symbol} />
              }
            
              { /* Chaitraly 14/feb/2025 :: Added type-20 condition for TP-397 Jira card */
                tourneyType == 20 ? 
                  (hourly ? <h4>Daily Small Fish</h4> : <h4>Hourly Small Fish</h4>) :
                  (hourly ? <h4>Daily Big Fish</h4> : <h4>Hourly Big Fish</h4>)
              }

              {
                hourly ? <DailyBigFish dailyBigFish={dailyBigFish} length_measurement_symbol = {length_measurement_symbol} weight_measurement_symbol = {weight_measurement_symbol}/> : <HourlyBigFish hourlyBigFish={hourlyBigFish} length_measurement_symbol = {length_measurement_symbol} weight_measurement_symbol = {weight_measurement_symbol} />
              }
            </div>        
          </Modal.Body>

        </Modal>
      
    </>
  )

  
}

export default BigFish